import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { CartService } from 'src/app/services/cart/cart.service';
import { LocationService } from 'src/app/services/location/location.service';
import { LoginService } from 'src/app/services/login/login.service';
import { OrderService } from 'src/app/services/order/order.service';
import { ThumaMinaService } from 'src/app/services/thuma-mina/thuma-mina.service';
import { LocationPage } from '../location/location.page';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {
  cartItems;
  cartPrice;
  totalPrice;
  deliveryPrice = 0;

  btnClicked = false;

  FeesObject = {};
  region;

  constructor(
    private router: Router,
    public cartService: CartService,
    private auth: AngularFireAuth,
    private loginService: LoginService,
    private modalController: ModalController,
    public locationService: LocationService,
    private orderService: OrderService,
    private thumaMinaService: ThumaMinaService
  ) {}

  ngOnInit() {
    this.locationService.address = '';
    this.cartItems = this.cartService.getCartItems();
    this.cartPrice = this.cartService.getCartPrice();
    this.totalPrice = this.cartService.getCartPrice() + this.deliveryPrice;
    this.getFees();
    console.log(this.cartItems);
  }

  allshops() {
    this.router.navigate(['all-shops']);
  }

  getFees() {
    this.orderService
      .getDeliveryFees()
      .pipe(take(1))
      .subscribe((res) => {
        if (res.exists) {
          this.FeesObject = res.data() as Object;
        }
      });
  }

  onSelectChange(event) {
    const { fee, region } = event.detail.value;
    this.deliveryPrice = fee;
    this.region = region;
  }

  addItem(item) {
    this.cartService.addToCart(item);
    this.cartPrice = this.cartService.getCartPrice();
    this.totalPrice = this.cartService.getCartPrice() + this.deliveryPrice;
  }

  removeItem(item) {
    this.cartService.removeItem(item);
    this.cartPrice = this.cartService.getCartPrice();
    this.totalPrice = this.cartService.getCartPrice() + this.deliveryPrice;
  }

  removeItems(item) {
    this.cartService.removeItems(item);
  }

  checkout() {
    this.btnClicked = true;
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      if (user) {
        if (this.locationService.address) {
          const region = this.region;
          const itemName = 'Order';
          const dropPointAddress = this.locationService.address;
          const pickUpAddress = this.cartService.store;
          const store = this.cartService.store;
          let description = '';

          this.cartItems.map((item) => {
            description =
              description +
              item.title +
              ' x ' +
              item.quantity +
              ' R' +
              item.price +
              '\n';
          });

          const details = {
            description,
            dropPointAddress,
            itemName,
            pickUpAddress,
            region,
            deliveryFee: this.deliveryPrice,
            store,
          };

          this.thumaMinaService.setDetails(details);

          this.router.navigate(['/make-order'], {
            queryParams: {
              requestType: 'delivery-only',
              requesterID: user.uid,
            },
          });
        } else {
          const userID = user.uid;
          this.loginService
            .verifyID(userID)
            .pipe(take(1))
            .subscribe((res: any) => {
              if (res.exists) {
                const data = res.data();
                const role = data.role;
                if (role === 'User') {
                  this.btnClicked = false;
                  this.cartService.setRequestBy(userID);
                  // this.router.navigate(['/location'], {
                  //   queryParams: { from: this.router.url, requestBy: userID },
                  // });
                  const area = 'Kanyamazane, Mpumalanga, South Africa, 1214';
                  this.modalController
                    .create({
                      cssClass: 'modal-fullscreen',
                      component: LocationPage,
                      componentProps: {
                        searchAddress: area,
                      },
                    })
                    .then((modalElem) => {
                      modalElem.present();
                    });
                } else {
                  this.btnClicked = false;
                  this.router.navigate(['/login'], {
                    queryParams: { from: this.router.url },
                  });
                }
              } else {
                this.btnClicked = false;
                this.router.navigate(['/login'], {
                  queryParams: { from: this.router.url },
                });
              }
            });
        }
      } else {
        this.btnClicked = false;
        this.router.navigate(['/login'], {
          queryParams: { from: this.router.url },
        });
      }
    });
  }

  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  login() {
    this.router.navigate(['home/login']);
  }
}
